import { createApp } from "vue";
import { createStore } from "vuex";
import clickOutside from "components/jiffy/vue-cart/filters/clickOutside";
import PdpMadeReviews from "./PdpMadeReviews.vue";
import "./pdp-made-reviews.scss";

export const initApp = (selector = "#pdp-made-reviews") => {
  const $mountPoint = document.querySelector(selector);
  // eslint-disable-next-line no-underscore-dangle
  if (!$mountPoint || $mountPoint?.__vue_app__) return;

  const app = createApp({});
  app.component("PdpMadeReviews", PdpMadeReviews);
  app.use(
    createStore({
      state: {}
    })
  );
  app.directive("click-outside", clickOutside());
  app.mount(selector);
};

export default initApp;
